import { baseApi } from "./baseApi";

const FREELOADING_BASE_URL = "/freeloading";

export const freeloadingApi = baseApi.injectEndpoints({
  tagTypes: ["Freeloading", "Collection", "Consolidation", "ShipmentLoading"],

  endpoints: (build) => ({
    // Add Freeloading (creates Collection, Consolidation, ShipmentLoading)
    addFreeloading: build.mutation({
      query: (body) => ({
        url: FREELOADING_BASE_URL,
        method: "POST",
        body,
      }),
      invalidatesTags: (result, error, body) => [
        { type: "Collection", id: "LIST" },
        { type: "Consolidation", id: "LIST" },
        { type: "ShipmentLoading", id: "LIST" },
        { type: "Freeloading", id: "LIST" },
        { type: "Shipment", id: "LIST" },
        ...(body?.shipmentId || []).map((id) => ({
          type: "Shipment",
          id: typeof id === "object" ? id._id : id,
        })),
        ...(result?.loading?.shipmentId || []).map((id) => ({
          type: "Shipment",
          id: typeof id === "object" ? id._id : id,
        })),
      ],
    }),
    addFreeloadingForDrivers: build.mutation({
      query: (body) => ({
        url: `${FREELOADING_BASE_URL}/freeloading-drivers`,
        method: "POST",
        body,
      }),
      invalidatesTags: (result, error, body) => [
        { type: "Collection", id: "LIST" },
        { type: "Consolidation", id: "LIST" },
        { type: "ShipmentLoading", id: "LIST" },
        { type: "Freeloading", id: "LIST" },
        { type: "Shipment", id: "LIST" },
        ...(body?.shipmentId || []).map((id) => ({
          type: "Shipment",
          id: typeof id === "object" ? id._id : id,
        })),
        ...(result?.loading?.shipmentId || []).map((id) => ({
          type: "Shipment",
          id: typeof id === "object" ? id._id : id,
        })),
      ],
    }),

    // List Freeloading Records
    listFreeloading: build.query({
      query: (params) => ({
        url: FREELOADING_BASE_URL,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ _id }) => ({
                type: "Freeloading",
                id: _id,
              })),
              { type: "Freeloading", id: "LIST" },
              { type: "Collection", id: "LIST" },
              { type: "Consolidation", id: "LIST" },
              { type: "ShipmentLoading", id: "LIST" },
            ]
          : [
              { type: "Freeloading", id: "LIST" },
              { type: "Collection", id: "LIST" },
              { type: "Consolidation", id: "LIST" },
              { type: "ShipmentLoading", id: "LIST" },
            ],
    }),

    // Get Freeloading Detail
    getFreeloadingDetail: build.query({
      query: (freeloadingId) => `${FREELOADING_BASE_URL}/${freeloadingId}`,
      providesTags: (result, error, id) => [
        { type: "Freeloading", id },
        { type: "Collection", id: "LIST" },
        { type: "Consolidation", id: "LIST" },
        { type: "ShipmentLoading", id: "LIST" },
      ],
    }),

    // Update Freeloading
    updateFreeloading: build.mutation({
      query: ({ id, ...body }) => ({
        url: `${FREELOADING_BASE_URL}/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "Freeloading", id },
        { type: "Collection", id: "LIST" },
        { type: "Consolidation", id: "LIST" },
        { type: "ShipmentLoading", id: "LIST" },
      ],
    }),

    // Delete Freeloading
    deleteFreeloading: build.mutation({
      query: (freeloadingId) => ({
        url: `${FREELOADING_BASE_URL}/${freeloadingId}`,
        method: "DELETE",
      }),
      invalidatesTags: [
        { type: "Freeloading", id: "LIST" },
        { type: "Collection", id: "LIST" },
        { type: "Consolidation", id: "LIST" },
        { type: "ShipmentLoading", id: "LIST" },
      ],
    }),

    // List Shipments by Freeloading ID
    listShipmentsByFreeloadingId: build.query({
      query: ({ freeloadingId, page, limit }) => ({
        url: `${FREELOADING_BASE_URL}/${freeloadingId}/shipments`,
        params: { page, limit },
      }),
      providesTags: (_result, _error, { freeloadingId }) => [
        { type: "Freeloading", id: freeloadingId },
        { type: "Collection", id: "LIST" },
        { type: "Consolidation", id: "LIST" },
        { type: "ShipmentLoading", id: "LIST" },
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useAddFreeloadingMutation,
  useAddFreeloadingForDriversMutation,
  useListFreeloadingQuery,
  useLazyListFreeloadingQuery,
  useGetFreeloadingDetailQuery,
  useUpdateFreeloadingMutation,
  useDeleteFreeloadingMutation,
  useListShipmentsByFreeloadingIdQuery,
  useLazyListShipmentsByFreeloadingIdQuery,
} = freeloadingApi;
